package link.erpango.quip.ui.ocr

import link.erpango.quip.domain.ocr.OcrError
import link.erpango.quip.domain.ocr.OcrResult

/**
 * JS/Web text recognition fallback — not implemented yet.
 */
actual object PlatformTextRecognition : TextRecognitionContract {
    actual override suspend fun recognize(imageBytes: ByteArray): OcrResult =
        OcrResult.failure(OcrError.UnsupportedPlatform)
}
